import React, { useState, useEffect } from "react";
import { message, Popconfirm, Result, Spin } from "antd";
import PageTop from "@/Pages/Project/PageTop";
import Navbar from "@/Components/navbar";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import userInfo from "@/Components/user";
import {
  projects,
  flows,
  delFlow,
  createFlow,
  updateFlow,
  uploadFile,
} from "@/services/common";
import { randomId } from "@/config/func";
import UpdataFlowInfo from "@/Components/CreateModal/UpdataFlowInfo";
import emptyImg from "@/assets/icons/empty.svg";
import "./userView.less";

const Component = (props: any) => {
  const [curSource, setCurSource] = useState<any>(null);
  const [loading, setloading] = useState(false);
  const [curFlowInfo, setCurFlowInfo] = useState<any>(null);
  const [updateFlowModalStatus, setUpdateFlowModalStatus] = useState(false);
  const navigate = useNavigate();

  //普通用户只有一个项目，取该项目及其流程列表
  const loadData = () => {
    setloading(true);
    projects(
      {
        owner_id: userInfo.id,
        page: 1,
        perPage: 1,
      },
      userInfo.access_token
    ).then((r) => {
      const project = r.data.data && r.data.data[0];
      if (!project) {
        setCurSource(null);
        setloading(false);
        return;
      }
      flows(project.id, { page: 1, perPage: 1000 }, userInfo.access_token).then(
        (f) => {
          setCurSource({
            ...project,
            flows: f.data.data,
          });
          setloading(false);
        }
      );
    });
  };

  useEffect(() => {
    loadData();
  }, []);

  //进入流程
  const openFlow = (item: any) => {
    let path = `/project/${curSource.id}/flow/${item.id}`;
    if (item.job_count > 0) {
      path += "/design1";
    } else if (
      item.global_data &&
      Object.keys(item.global_data).length > 0
    ) {
      path += "/design1";
    } else {
      path += "/setting";
    }
    navigate(path);
  };

  //删除流程
  const del_confirm = async (project_id: any, flowId: number) => {
    try {
      await delFlow(project_id, flowId, userInfo.access_token).then((r) => {
        if (r.status === 200) {
          message.success("流程已删除!");
          loadData();
        } else {
          message.error("流程删除失败!");
        }
      });
    } catch (error) {
      const str = error?.response?.data?.detail || "删除失败";
      message.error(str);
    }
  };

  //下载原流程数据并改名后重新上传，返回新文件地址
  async function downloadAndRename(curFlow) {
    try {
      const response = await fetch(curFlow.flow_data_url);
      const jsonData = await response.json();
      const newFileName = `flow_${curFlow.project_id}_${curFlow.id
        }_${randomId()}_modified.json`;
      const blob = new Blob([JSON.stringify(jsonData)], {
        type: "application/json",
      });
      const formData = new FormData();
      formData.append("file", blob, newFileName);
      const uploadResponse = await uploadFile(formData, userInfo.access_token);
      const result = await uploadResponse.json();
      return result.fileUrl;
    } catch (error) {
      console.error("处理失败:", error);
      throw error;
    }
  }

  //复制流程
  const handleCopy = (item) => {
    downloadAndRename(item).then((newUrl) => {
      const subData = {
        name: "未命名的流程",
        description: item.description,
        thumbnail_url: item.thumbnail_url,
        flow_data_url: newUrl,
        global_data: item.global_data,
      };
      createFlow(curSource.id, subData, userInfo.access_token).then((r) => {
        if (r.status === 200) {
          updateFlow(
            r.data.project_id,
            r.data.id,
            subData,
            userInfo.access_token
          ).then((r) => {
            if (r.status === 200) {
              message.success("流程复制成功！");
              loadData();
              navigate(`/project/${curSource.id}/flow/${r.data.id}/setting`);
            } else {
              message.error("流程复制失败！");
            }
          });
          loadData();
        } else {
          message.error("流程复制失败！");
        }
      });
    });
  };

  return (
    <>
      <PageTop
        mainContent={
          <Navbar />
        }
      />
      <div className="userViewPage">
        {loading ? (
          <div className="userViewLoading">
            <Spin />
          </div>
        ) : (
          <ul className="flowImgList mt1">
            {curSource && curSource.flows && curSource.flows.length > 0 ? (
              curSource.flows.map((item: any, index: any) => (
                <li key={index}>
                  <div
                    className="imgInner showSImgborder"
                    onClick={() => openFlow(item)}
                  >
                    <div className="showSImg">
                      <div className="showSImg_inner">
                        {item.thumbnail_url ? (
                          <img src={item.thumbnail_url} alt="" />
                        ) : (
                          <div className="nopic">
                            <div>
                              <img
                                src={emptyImg}
                                alt=""
                                style={{ height: "auto", width: "auto" }}
                              />
                              <div className="notext">暂无封面</div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="showFname">
                    <div className="sp_left">
                      <div className="sp_name">{item.name}</div>
                      
                    </div>
                    {/* <div className="sp_right">
                      <div
                        className="sp_icon sp_icon_copy"
                        title="复制"
                        onClick={() => handleCopy(item)}
                      />
                      <div
                        className="sp_icon sp_icon_edit"
                        title="修改"
                        onClick={() => {
                          setCurFlowInfo(item);
                          setUpdateFlowModalStatus(true);
                        }}
                      />
                      <Popconfirm
                        title="确定删除该流程吗？"
                        description="删除后不可恢复！"
                        onConfirm={async () => {
                          await del_confirm(item.project_id, item.id);
                        }}
                        okText="是"
                        cancelText="否"
                      >
                        <div className="sp_icon sp_icon_delete" title="删除" />
                      </Popconfirm>
                    </div> */}
                  </div>
                </li>
              ))
            ) : (
              <div className="userFlowEmpty">
                <Result
                  status="info"
                  title={
                    <div className="userFlowEmptyText">
                      暂时没有创建的流程，请添加流程！
                    </div>
                  }
                ></Result>
              </div>
            )}
          </ul>
        )}

        {curFlowInfo ? (
          <UpdataFlowInfo
            status={updateFlowModalStatus}
            setStatus={setUpdateFlowModalStatus}
            userInfo={userInfo}
            loadData={loadData}
            source={curFlowInfo}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default Component;
